import { PaymentMethods } from '@/utils/enums';

export const PAYMENT_METHODS = [
  { label: 'Наличными', value: PaymentMethods.CASH },
  { label: 'Банк', value: PaymentMethods.BANK },
  { label: 'Kaspi Gold', value: PaymentMethods.KASPI_GOLD },
  { label: 'POS-терминал', value: PaymentMethods.POS_TERMINAL },
  { label: 'Мобильное приложение', value: PaymentMethods.MOBILE_APP },
];
